export function moTaLoiJob(loi: string): string {
  if (/DISPATCHED_MAT_PHAN_HOI|TIMEOUT_REAPER|HET_GIO_CHO_EXTENSION|EXECUTION_RESULT_UNCONFIRMED/.test(loi)) {
    return 'Chưa xác định: thao tác có thể đã thực hiện. Kiểm tra trên Facebook trước khi quyết định, không gửi lại tự động.';
  }
  return loi;
}
